module.exports = __webpack_public_path__ + "static/media/smartRad.54395275.png";